const Payment = () => import('./pages/Payment.vue');

export default [
  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    meta: {
      title: 'Pagamentos',
    },
  },
];
